import type { ReactNode } from "react";
import { Link } from "react-router-dom";

type SectionHeadingProps = {
  eyebrow?: string;
  title: string;
  desc?: string;
  linkText?: string;
  linkTo?: string;
  align?: "left" | "center";
  extra?: ReactNode;
};

export default function SectionHeading({
  eyebrow,
  title,
  desc,
  linkText,
  linkTo,
  align = "left",
  extra,
}: SectionHeadingProps) {
  const centered = align === "center";

  return (
    <div
      className={`flex flex-col gap-4 ${
        centered ? "items-center text-center" : "md:flex-row md:items-end md:justify-between"
      }`}
    >
      <div className={centered ? "max-w-2xl" : "max-w-2xl"}>
        {eyebrow ? (
          <p className="mb-3 flex items-center gap-2 text-xs font-medium tracking-[0.28em] text-primary-600">
            <span className={`h-px w-6 bg-primary-500 ${centered ? "hidden" : ""}`} />
            {eyebrow}
          </p>
        ) : null}
        <h2 className="font-heading text-2xl font-bold tracking-tight text-foreground-950 md:text-[32px] md:leading-[1.25]">
          {title}
        </h2>
        {desc ? <p className="mt-3 text-sm leading-7 text-foreground-600 md:text-[15px]">{desc}</p> : null}
      </div>
      {extra}
      {linkText && linkTo ? (
        <Link
          to={linkTo}
          className="group inline-flex shrink-0 items-center gap-1.5 whitespace-nowrap rounded-md border border-background-300 px-4 py-2 text-sm text-foreground-800 transition-colors hover:border-primary-400 hover:text-primary-700"
        >
          {linkText}
          <i
            className="ri-arrow-right-line text-base transition-transform group-hover:translate-x-0.5"
            aria-hidden="true"
          />
        </Link>
      ) : null}
    </div>
  );
}